export type ConstituentComplaintTask = {
  id: number;
  constituent_complaint_id: number;
  user_id: number;
  title: string;
  due_at: string | null;
  completed_at: string | null;
  position: number;
  created_at: string;
  updated_at: string;
};

export type ConstituentComplaintTaskPayload = {
  title?: string;
  due_at?: string | null;
  completed_at?: string | null;
  position?: number;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function tasksPath(municipalityId: number, complaintId: number, taskId?: number): string {
  const base = `/api/v1/municipalities/${municipalityId}/trust_complaints/${complaintId}/tasks`;
  return taskId != null ? `${base}/${taskId}` : base;
}

export async function listConstituentComplaintTasks(
  municipalityId: number,
  complaintId: number,
): Promise<ConstituentComplaintTask[]> {
  const response = await fetch(tasksPath(municipalityId, complaintId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Failed to load tasks");
  return response.json();
}

export async function createConstituentComplaintTask(
  municipalityId: number,
  complaintId: number,
  payload: Pick<ConstituentComplaintTaskPayload, "title" | "due_at">,
): Promise<ConstituentComplaintTask> {
  const response = await fetch(tasksPath(municipalityId, complaintId), {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({ constituent_complaint_task: payload }),
  });
  if (!response.ok) throw new Error("Failed to create task");
  return response.json();
}

export async function updateConstituentComplaintTask(
  municipalityId: number,
  complaintId: number,
  taskId: number,
  patch: ConstituentComplaintTaskPayload,
): Promise<ConstituentComplaintTask> {
  const response = await fetch(tasksPath(municipalityId, complaintId, taskId), {
    method: "PATCH",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({ constituent_complaint_task: patch }),
  });
  if (!response.ok) throw new Error("Failed to update task");
  return response.json();
}

export async function deleteConstituentComplaintTask(
  municipalityId: number,
  complaintId: number,
  taskId: number,
): Promise<void> {
  const response = await fetch(tasksPath(municipalityId, complaintId, taskId), {
    method: "DELETE",
    credentials: "include",
    headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
  });
  if (!response.ok) throw new Error("Failed to delete task");
}
